import { createRoot } from 'react-dom/client'

import App from './App/App'

import './index.styl'

const container = document.getElementById('js-mapframe')
const root = createRoot(container)

root.render(<App />)
